export { default } from './ContentSwitcher';
